import { useLanguage } from '@/src/contexts';
import { getText, TranslationKey } from '@/src/helpers';
import { Token } from '@/src/models';
import {
  Flex,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Text,
} from '@/src/ui-components';
import { useFormContext } from 'react-hook-form';
import { TradePanelFormValues } from '../../trade-panel.types';

type OrderParameterProps = {
  formName: keyof TradePanelFormValues;
  title: Extract<TranslationKey, 'limitPrice' | 'quantity' | 'totalPrice'>;
  token: Token;
};

export const OrderParameter = ({ formName, title, token }: OrderParameterProps) => {
  const { language } = useLanguage();
  const { control } = useFormContext<TradePanelFormValues>();

  return (
    <FormField
      control={control}
      name={formName}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            <Flex align="center" justify="between">
              {getText(language, title)}
              <Text size="sm" weight="medium" className="text-muted-foreground">
                {token?.description || ''}
              </Text>
            </Flex>
          </FormLabel>
          <FormControl>
            <Input {...field} placeholder="0.00" />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
